export const formatNumber = (value: any) => {
  if (value === null || value === undefined) return '-';
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  return num.toLocaleString('mn-MN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const YEAR_OPTIONS = ['2025', '2026'] as const;

export const DEFAULT_YEAR_TYPE = YEAR_OPTIONS[YEAR_OPTIONS.length - 1];

/** UI PeriodType сонголтууд */
export const PERIOD_TYPE_OPTIONS = [
  { value: '2', label: '1-6 сар' },
  { value: '4', label: '1-12 сар' },
] as const;

export const getPeriodTypeLabel = (periodType?: string) =>
  PERIOD_TYPE_OPTIONS.find(o => o.value === periodType)?.label ?? '-';

/** UI PeriodType (2=1-6 сар, 4=1-12 сар) → API сарын дээд хязгаар */
export const resolvePeriodTypeForApi = (periodType?: string): string | undefined => {
  const map: Record<string, string> = { '2': '6', '4': '12' };
  if (!periodType || periodType === '0') return undefined;
  return map[periodType] ?? periodType;
};

/** AccountPeriodClose API-д илгээх PeriodType (6, 12 гэх мэт) */
export const getAccountPeriodClosePeriodType = (periodType?: string): number => {
  const apiPeriodType = resolvePeriodTypeForApi(periodType);
  return apiPeriodType ? parseInt(apiPeriodType, 10) : 0;
};

export const buildAccountPeriodCloseQueryParams = (
  customerOid: string,
  yearType: string,
  periodType?: string
) => {
  const params = new URLSearchParams({
    CustomerOid: customerOid,
    YearType: yearType,
  });
  const apiPeriodType = resolvePeriodTypeForApi(periodType);
  if (apiPeriodType) {
    params.append('PeriodType', apiPeriodType);
  }
  return params;
};

/** PeriodType сарын сүүлийн өдөр (6 → YYYY-06-30, 12 → YYYY-12-31) */
export const getPeriodEndPostDate = (year: number | string, periodType?: string): string => {
  const yearNum = typeof year === 'string' ? parseInt(year, 10) : year;
  const month = parseInt(resolvePeriodTypeForApi(periodType) ?? '12', 10);
  const lastDay = new Date(yearNum, month, 0);
  const yyyy = lastDay.getFullYear();
  const mm = String(lastDay.getMonth() + 1).padStart(2, '0');
  const dd = String(lastDay.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const formatDate = (value: any) => {
  if (!value) return '-';
  
  // If it's already in YYYY-MM-DD format, return as is
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  
  // If it's an ISO string, extract the date part directly (YYYY-MM-DD)
  if (typeof value === 'string' && value.includes('T')) {
    return value.split('T')[0];
  }
  
  // Otherwise, try to parse as Date
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toISOString().slice(0, 10);
};
